const bindingMap = {
  other: 'Annet',
  hardback: 'Innbundet',
  paperback: 'Heftet',
};

// eslint-disable-next-line import/prefer-default-export
export function mapBinding(dataBinding) {
  if (!dataBinding) {
    return bindingMap.other;
  }

  const binding = dataBinding.toLowerCase();

  if (!Object.keys(bindingMap).includes(binding)) {
    return bindingMap.other;
  }

  return bindingMap[binding];
}
